const initState = {
    modal: false,
};

const auth = function (state = initState, action) {
    switch (action.type) {
        case 'SET_AUTH_MODAL':
            return {
                ...state,
                modal: action.data.modal,
            }
      default:
        return state;
    }
}

export default auth;